// The branch (office) a broker last worked in is remembered per user, so a new tab or login reopens it.
// Storage can be unavailable (private mode, blocked site data) so every access is guarded.

const storageKey = (userID: string): string => `activeBranch:${userID}`

export const getRememberedBranch = (
  userID: string | undefined
): string | undefined => {
  if (!userID) {
    return undefined
  }

  try {
    return window.localStorage.getItem(storageKey(userID)) || undefined
  } catch {
    return undefined
  }
}

export const rememberBranch = (
  userID: string | undefined,
  companyID: string | undefined
): void => {
  if (!userID) {
    return
  }

  try {
    if (companyID) {
      window.localStorage.setItem(storageKey(userID), companyID)
    } else {
      window.localStorage.removeItem(storageKey(userID))
    }
  } catch {
    // the branch just won't be remembered
  }
}
